function getColumn(columns, name) {
  return columns.find(column => column.name === name)
}

export function getColumnWidth(columns, name) {
  return getColumn(columns, name).width
}

export function getColumnResizeLimits(config, columnName) {
  const hasCustomWidth = columnName in config

  return {
    maxWidth: hasCustomWidth ? config[columnName].max : config.common.max,
    minWidth: hasCustomWidth ? config[columnName].min : config.common.min,
  }
}

export function getColumnMaxWidth({ columnName, config, currentWidth }) {
  if (!columnName) {
    return currentWidth
  }

  return columnName in config ? config[columnName].max : config.common.max
}

export function getColumnMinWidth({ columnName, config, currentWidth }) {
  if (!columnName) {
    return currentWidth
  }

  return columnName in config ? config[columnName].min : config.common.min
}
